var initialTopOffset;
var sidebarWidth;

var initializeSidebar = function() {
  $(document).off('scroll.fix-sidebar').on('scroll.fix-sidebar', _.debounce( function() {
    setScrolling(this);
  }, 10 ));
  // add listener for keydown so that the right panel adjusts while tabbing through the page as well as scrolling
  $(document).off('keydown.fix-sidebar').on('keydown.fix-sidebar', function() {
    setScrolling(this);
  });

};

var setScrolling = function(doc) {
  var $sidebar = $('.js-fixedSidebar'),
    $footer = $('.site-footer'),
    $doc = $(doc),
    topPadding = 26,
    exemptArr = $sidebar.length > 0 ? $sidebar.data().fixSidebarExempt.split(',') : [],
    deviceSize = Kadenze.Layout.getDeviceSize();
  // checks devices sizes and sees if it should be excluded from scrolling
  for (var i = -1, len = exemptArr.length; ++i < len;) {
    if(exemptArr[i]==deviceSize) {
      $sidebar.css({top: '', position: '', width: ''});
      return;
    }
  }
  // initializing top offset if it hasn't been set
  if(!initialTopOffset && $sidebar.length > 0){
    initialTopOffset = $sidebar.offset().top - topPadding;
    sidebarWidth = $sidebar.outerWidth();
  }
  var sidebarVisualHeight = $sidebar.outerHeight(true),
    footerHeight = $footer.outerHeight(),
    documentHeight = $doc.height(),
    scrollTop = $doc.scrollTop();
  // if scrolled away from top
  if ($doc.scrollTop() > initialTopOffset) {
    $sidebar.css({top: topPadding, position: 'fixed', width: sidebarWidth});
  } else {
    $sidebar.css({top: '', position: '', width: ''});
  }
  // check to end scrolling at footer
  if ( scrollTop > (documentHeight - sidebarVisualHeight - footerHeight - topPadding) ) {
    $sidebar.css('top', -(scrollTop - (documentHeight - sidebarVisualHeight - footerHeight)));
  }
};

export default {
  init: function() {
    initializeSidebar();
  }
};
